module.exports = __webpack_public_path__ + "assets/img/banner7.eb0589bd.jpg";